import { SET_SYSTEM_BANNERS, DISMISS_SYSTEM_BANNER, CLEAR_DISMISSED_BANNERS } from "./systemBannerActionTypes";
import { SystemBanner } from "Network/Core/SystemBanners/systemBanners";

export const setSystemBanners = (banners: SystemBanner[]) => {
  return {
    type: SET_SYSTEM_BANNERS,
    payload: banners,
  };
};

export const dismissSystemBanner = (bannerId: number) => {
  return {
    type: DISMISS_SYSTEM_BANNER,
    payload: bannerId,
  };
};

export const clearDismissedBanners = () => {
  return {
    type: CLEAR_DISMISSED_BANNERS,
  };
};
